import { memo } from 'react';

import { type UseTrackCanvasCreatedParams } from '@air/analytics';

import { useAllContentActions } from '~/components/AllContent/hooks/useAllContentActions';
import { CreateDropdownButton } from '~/components/Shared/HeaderBar/CreateDropdownButton';
import { useWorkspaceRightPanelOpen } from '~/components/v2/store/features/workspace/useWorkspaceRightPanelOpen';

export type WorkspaceCreateButtonProps = {
  canvasSource?: UseTrackCanvasCreatedParams['source'];
};

export const WorkspaceCreateButton = memo(({ canvasSource }: WorkspaceCreateButtonProps) => {
  const isRightPanelOpen = useWorkspaceRightPanelOpen();
  const { createOptions } = useAllContentActions({
    trackLocation: 'header-bar-add-button',
    canvasSource,
  });

  if (isRightPanelOpen) {
    const canvasOption = createOptions.find((opt) => opt.id === 'create-new-canvas');

    if (!canvasOption) {
      return null;
    }

    return <CreateDropdownButton options={[canvasOption]} data-testid="ALL_CONTENT_CREATE_BUTTON" />;
  }

  if (!createOptions.length) {
    return null;
  }

  return <CreateDropdownButton options={createOptions} data-testid="ALL_CONTENT_CREATE_BUTTON" />;
});

WorkspaceCreateButton.displayName = 'WorkspaceCreateButton';
